export const BASE_URI_PROGRESS = '/academy/learning-center/progress/v1';

/**
 * This is the base URI for all the services belonging to the learning center.
 * Many different services which are deployed separately will be served under this URI.
 */
export const BASE_SERVICE_URI = '/academy/learning-center';
export const ACADEMY_CATALOG_SERVICE_URI = '/academy-catalog/v1';
export const ACADEMY_CATALOG_SERVICE_URI_V2 = '/academy-catalog/v2';
export const HUBLET_AWARE_SERVICE_URI = '/learning/center/hublet/aware';
export const ACADEMY_AI_SERVICE_URI = '/academy/ai';
export const DEFAULT_LANGUAGE = 'en';
export const HTTP_STATUS_LOCKED = 423;
export const DEBOUNCE_WAIT_API = 1000;